import { gql } from 'graphql.macro';

export const UpdateDepot = gql`
  mutation updateManagedDepot($request: DepotCollectionUpdateRequestModelInput!) {
    updateObservationDepotManagers(request: $request)
  }
`;